<template>
    <poverty-visualization :charts="charts" :line-chart="lineChart" :area-chart="areaChart" :title="title"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Porcentaje de personas en situación de pobreza Multidimensional',
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSPYLqNbQ9lPM1C4mnKe8LoZwBEEMiCQ8bwi7shOk-RYLnGwET39CZu5oBdnF_OuNY_Ng3UJNZ-jzY2/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSoJQrWvh4LtowNIBl0dMNJaRyv9vkkk2g5NbfTL5sRtJFBk00HPLK2r0fx_mKIPYQGC5eMN-7C1IUV/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','zona']
                    },
                    {
                        id: 'genero',
                        title: 'Genero',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQDYWpZuFBsgZxBVIwCSNb52Fyi3k6VlyfGCxQEgoO8DUpVC5FLcOOLhi7D9wGYoUJFDpMbTX3k-tlV/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTyduKoe4b6YHHojEDpCOq3xojdL7l3xh3CeO5GrF9O2Ixa5_lmy7gdOhpx93_M6vjLO2xzOuaGAOWo/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','genero']
                    },
                    {
                        id: 'edades',
                        title: 'Rangos Etarios',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTDBIlIczu7UvPOoWFwR0o3Yvu6IPVnsmf0EECY4BjgamxWMEKN-urmxetGArsZD7MLcMUEfjCtaH3T/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSBTijp08ckzMWf_JqbEZ0GviExwxUy_Qhwm-jSpKfqA2UODym59Vz_okR2ajj4cILJhsbW__oAaaaK/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','edades']
                    },
                    {
                        id: 'pueb_indig',
                        title: 'Pueblos Indigenas',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSh-OPmPH6IRM_yHEY1xDQTGre2Y4nLO33x05QVyEo2TG8664FJRbGp-iLgBI_42xiZP6fRA4dnEMk5/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQjYkypZuebhMoA6EIvKCfIXHhYFnyAm9oKf7_k335LF0XOpoC2LGGTMo2d3Snf6oyUfrcu02AXgErk/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','pueb_indig']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQhzxduJ0E3u8zhn5q74zRYkJ5deC03TwEYB1lWRkBw_ySJymsFpvTrJ3bcNdo5bYuhI-weq9GCoM2m/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTAmPaPa6i8xbZC2P2RytLhOAO5_Ko21AgFdtjS2KqUq-we8JbuGz-IFU3ORzUbb4hqIe7tFlToSYhT/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','quintil']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTBHUvWPnJxzcbDqssSVn0zF8mvDp1fW2K56LbfaETXjVa1mlnhQErUOLadNoo8hhAoq2XguQ_p2r_M/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQvzGSwgz-cnL1K3a7QUfwxTgwVWXWrrr-alcMZdoKiKfFZ3aDZ2EjTDFAEiY88eQZsaT9Tsbc7RCDR/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','migrantes']
                    }
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRm5DKR7E11au6_rMgha8kHnkM1f79rn-b5DF_GHUkwqMwOiTLh7ohBMortuGChEUiJTGrLqlWcTI1p/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSmnPbToBDLw0I1uSpwu4mBOtVEbwZkA8pK2ULWwQmTYDJk490T4jvOzoE1lQFu-3kJxPjOHYLp9qFp/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/PovertyMultiVisualization.vue